import { PointerEvent as ReactPointerEvent } from "react";
import { Box, useMediaQuery } from "@mui/material";
import Rows from "../../../library/components/layout/Rows";
import appColors from "../../../app/appColors";
import PdfCanvasReadonlyNotMarkers from "./PdfCanvasReadonlyNotMarkers";
import type { HesapSarkiSesKayitNotlarModel } from "../../../models/businessModels/HesapSarkiSesKayitNotlarModel";
import type {
    PdfCanvasColorMeaning,
    PdfCanvasEraserCursorState,
    PdfCanvasPageMeta,
    PdfCanvasToolType,
} from "./pdfCanvasTypes";

interface IPdfCanvasPageProps {
    pageIndex: number,
    pageCount: number,
    imageUri: string,
    readOnly: boolean,
    seciliArac: PdfCanvasToolType,
    seciliRenk: string,
    eraserCursor: PdfCanvasEraserCursorState,
    displayBrushRadius: number,
    readonlyMarkers: {
        pageMeta: PdfCanvasPageMeta,
        pageNotlar: HesapSarkiSesKayitNotlarModel[],
        legendItems: PdfCanvasColorMeaning[],
        onDinleNot: (not: HesapSarkiSesKayitNotlarModel) => void,
    } | null,
    setImageRef: (el: HTMLImageElement | null) => void,
    setCanvasRef: (el: HTMLCanvasElement | null) => void,
    onImageLoad: () => void,
    onPointerDown: (event: ReactPointerEvent<HTMLCanvasElement>) => void,
    onPointerMove: (event: ReactPointerEvent<HTMLCanvasElement>) => void,
    onPointerUp: () => void,
    onPointerLeave: () => void,
    onPointerEnter: () => void,
}

const PdfCanvasPage = (props: IPdfCanvasPageProps) => {
    // Tablet gibi dokunmatik birincil cihazlarda kenarlardan scroll için yan boşluğu artır.
    const isCoarsePointer = useMediaQuery("(pointer: coarse)");
    const showBrushPreview = !props.readOnly
        && props.seciliArac !== "none"
        && props.eraserCursor.visible
        && props.eraserCursor.pageIndex === props.pageIndex;

    return <Rows id={`pdf_canvas_page_${props.pageIndex}`} style={{ alignSelf: "center" }}>
        <p style={{ textAlign: "center", marginTop: "5px" }}>
            Sayfa {props.pageIndex + 1} / {props.pageCount}
        </p>
        <Box style={{ background: appColors.GRAY_LIGHT2, padding: "10px", position: "relative" }}>
            <img
                ref={props.setImageRef}
                onLoad={props.onImageLoad}
                alt={""}
                title={""}
                src={props.imageUri}
                style={{ width: "100%", background: appColors.WHITE, display: "block" }} />
            <canvas
                ref={props.setCanvasRef}
                onPointerDown={props.onPointerDown}
                onPointerMove={props.onPointerMove}
                onPointerUp={props.onPointerUp}
                onPointerLeave={props.onPointerLeave}
                onPointerEnter={props.onPointerEnter}
                style={{
                    position: "absolute",
                    left: "10px",
                    top: "10px",
                    width: "calc(100% - 20px)",
                    height: "calc(100% - 20px)",
                    touchAction: props.readOnly ? "auto" : "none",
                    cursor: props.readOnly || props.seciliArac === "none"
                        ? "default"
                        : (props.seciliArac === "erase" ? "cell" : "crosshair"),
                }} />
            {props.readonlyMarkers === null ? null
                : <PdfCanvasReadonlyNotMarkers
                    pageMeta={props.readonlyMarkers.pageMeta}
                    pageNotlar={props.readonlyMarkers.pageNotlar}
                    legendItems={props.readonlyMarkers.legendItems}
                    onDinleNot={props.readonlyMarkers.onDinleNot}
                />}
            {!showBrushPreview ? null
                : <div
                    style={{
                        position: "absolute",
                        left: `calc(10px + ${props.eraserCursor.x - props.displayBrushRadius}px)`,
                        top: `calc(10px + ${props.eraserCursor.y - props.displayBrushRadius}px)`,
                        width: `${props.displayBrushRadius * 2}px`,
                        height: `${props.displayBrushRadius * 2}px`,
                        borderRadius: "50%",
                        border: props.seciliArac === "erase"
                            ? "1px solid rgba(90,90,90,0.9)"
                            : "1px solid rgba(0,0,0,0.7)",
                        background: props.seciliArac === "erase"
                            ? "rgba(160,160,160,0.25)"
                            : props.seciliRenk.replace(", 1)", ", 0.30)"),
                        pointerEvents: "none",
                        zIndex: 2,
                    }}
                />}
        </Box>
    </Rows>;
};

export default PdfCanvasPage;
